import * as React from 'react';
import { Check } from '@mui/icons-material';
import { Button, Stack, Typography } from '@mui/material';
import { usePostHog } from '@posthog/react';
import { useQuery } from '@tanstack/react-query';

import { me } from '#lib/react-query/queries.ts';

/**
 * Early Access Feature key from PostHog (Early access features → "Readiness agent actions"). Joining
 * the waitlist enrolls the user in this feature.
 */
const READINESS_AGENT_ACTIONS_FEATURE_KEY = 'readiness-agent-actions';

export function ReadinessWaitlist() {
  const posthog = usePostHog();
  const { data: { user, org } = {} } = useQuery(me);
  const [hasJoined, setHasJoined] = React.useState(false);

  function handleJoin() {
    // Optimistic: flip immediately and fire the PostHog calls in the background. Enrollment is
    // best-effort (client-side, ad-blockable) and we don't gate the UI on it.
    setHasJoined(true);

    // Identity is sent only here, at the explicit opt-in — everywhere else stays anonymous. Identify
    // before enrolling so `person_profiles: 'identified_only'` keeps the enrollment.
    if (user?.id) {
      posthog.identify(String(user.id), {
        email: user.email,
        role: user.role,
        org_id: org?.id,
        org_name: org?.name,
      });
    }

    posthog.updateEarlyAccessFeatureEnrollment(READINESS_AGENT_ACTIONS_FEATURE_KEY, true);
  }

  return (
    <Stack direction="column" spacing={1} alignItems="center" marginTop={3}>
      <Typography variant="body2" color="text.secondary">
        Want Mia to handle these actions for you automatically?
      </Typography>
      <Button
        variant="outlined"
        size="small"
        color="quaternary"
        onClick={handleJoin}
        disabled={hasJoined}
        startIcon={hasJoined ? <Check /> : undefined}
      >
        {hasJoined ? "You're on the list" : 'Join the waitlist'}
      </Button>
    </Stack>
  );
}
